import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ClaimsRoutingEnum } from '@app/my-zone/pages/claims/claims-routing.enum';
import { ClaimsOverviewContainer } from './claims-overview.container';
import { ClaimsComponent } from './claims.component';

const routes: Routes = [
    {
        path: '',
        component: ClaimsComponent,
        children: [
            {
                path: '',
                pathMatch: 'full',
                component: ClaimsOverviewContainer,
            },
            {
                path: ClaimsRoutingEnum.DamageClaim,
                loadChildren: () => import('./damage-claim/damage-claim.module').then((m) => m.DamageClaimModule),
            },
        ],
    },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ClaimsRoutingModule { }
